import { ref } from 'vue'

// Create a singleton state that can be shared across components
const isGalleryOpen = ref(false)
const isModalOpen = ref(false)

// Computed property to determine if keyboard navigation should be active
const isKeyboardNavigationDisabled = () => isGalleryOpen.value || isModalOpen.value

export function useKeyboardNavigation() {
  const openGallery = () => {
    isGalleryOpen.value = true
  }

  const closeGallery = () => {
    isGalleryOpen.value = false
  }

  const openModal = () => {
    isModalOpen.value = true
  }

  const closeModal = () => {
    isModalOpen.value = false
  }

  return {
    isGalleryOpen,
    isModalOpen,
    isKeyboardNavigationDisabled,
    openGallery,
    closeGallery,
    openModal,
    closeModal,
  }
}
